import React from "react";
import { useTranslation } from "react-i18next";

const FormActions = ({ onSubmit, isSubmitting, disabled = false }) => {
  const { t } = useTranslation();

  return (
    <div className="kt-portlet__foot">
      <div className="kt-form__actions text-right">
        {!isSubmitting ? (
          <button
            type="submit"
            onClick={onSubmit}
            className="btn btn-primary"
            disabled={disabled}
          >
            {t("Modifier")}
          </button>
        ) : (
          <button
            className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light"
            type="button"
            disabled
          >
            {t("Chargement")}...
          </button>
        )}
      </div>
    </div>
  );
};

export default FormActions;
